/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TransformerDeployer,
  TransformerDeployerInterface,
} from "../TransformerDeployer";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "initialAuthorities",
        type: "address[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "AuthorizedAddressAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "AuthorizedAddressRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Deployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "Killed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "addAuthorizedAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "authorities",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
    ],
    name: "deploy",
    outputs: [
      {
        internalType: "address",
        name: "deployedAddress",
        type: "address",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "getAuthorizedAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IKillable",
        name: "target",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "ethRecipient",
        type: "address",
      },
    ],
    name: "kill",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "removeAuthorizedAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "removeAuthorizedAddressAtIndex",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "toDeploymentNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class TransformerDeployer__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    initialAuthorities: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TransformerDeployer> {
    return super.deploy(
      initialAuthorities,
      overrides || {}
    ) as Promise<TransformerDeployer>;
  }
  getDeployTransaction(
    initialAuthorities: string[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(initialAuthorities, overrides || {});
  }
  attach(address: string): TransformerDeployer {
    return super.attach(address) as TransformerDeployer;
  }
  connect(signer: Signer): TransformerDeployer__factory {
    return super.connect(signer) as TransformerDeployer__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TransformerDeployerInterface {
    return new utils.Interface(_abi) as TransformerDeployerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TransformerDeployer {
    return new Contract(address, _abi, signerOrProvider) as TransformerDeployer;
  }
}
